var _style, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWarning(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "warning_2_",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 96 96",
    style: {
      enableBackground: "new 0 0 96 96"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#FFC500;}\r\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M46.266,37.197h3.6c0.988,0,1.649,0.665,1.649,1.649l-0.43,21.99c0,0.984-0.625,1.631-1.596,1.631h-2.793 c-0.728,0-1.596-0.284-1.596-1.645l-0.43-21.958C44.671,37.482,45.538,37.197,46.266,37.197z M50.243,66.749h-4.517 c-0.91,0-1.432,0.544-1.432,1.485v3.92c0,0.945,0.522,1.485,1.432,1.485h4.517c0.927,0,1.482-0.554,1.482-1.485v-3.92 C51.725,67.304,51.17,66.749,50.243,66.749z M93.547,79.834c0.029,3.311-2.462,8.199-5.839,9.786L86.9,90H9.309l-0.792-0.361 C4.981,88.023,2.582,83.157,2.64,79.8l0.018-1.034l38.839-67.271l0.651-0.49c2.908-2.189,8.75-2.224,11.794-0.07l0.716,0.506 l38.879,67.34L93.547,79.834z M85.343,80.587L48.856,17.391c-0.466-0.064-1.055-0.069-1.519-0.012L10.821,80.627 C11,81.088,11.288,81.621,11.565,82h73.011C84.857,81.607,85.152,81.063,85.343,80.587z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarning);
export default __webpack_public_path__ + "static/media/warning.59ef4d1692a80b7d65982736bffc5879.svg";
export { ForwardRef as ReactComponent };